import { Link } from "react-router";

import { PATHS } from "@/app/routes/paths";
import { Button } from "@/shared/components/ui/button";

export function NotFoundPage() {
  return (
    <div className="flex h-[70vh] flex-col items-center justify-center gap-4">
      <p className="text-6xl font-semibold text-slate-300">404</p>
      <p className="text-slate-600">The page you requested does not exist.</p>
      <Button asChild>
        <Link to={PATHS.dashboard}>Back to Dashboard</Link>
      </Button>
    </div>
  );
}
